import { type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: "/bookings",
    name: ROUTE_NAME.BOOKINGS,
    meta: { requiresPayments: true },
    component: () => import("./views/BookingsView.vue"),
  },
  {
    path: "/bookings/:bookedServiceId",
    name: ROUTE_NAME.BOOKING_DETAIL,
    meta: { requiresPayments: true },
    component: () => import("./views/BookedServiceView.vue"),
    props: true,
  },
  {
    path: "/bookings/:bookedServiceId/edit",
    name: ROUTE_NAME.BOOKING_DETAIL_EDIT,
    meta: { requiresPayments: true },
    component: () => import("./views/BookedServiceEditView.vue"),
    props: true,
  },
  {
    path: "/bookings/services/create",
    name: ROUTE_NAME.BOOKINGS_SERVICE_CREATE,
    meta: { requiresPayments: true },
    component: () => import("./views/CreateServiceView.vue"),
  },
  {
    path: "/bookings/services/edit/:id",
    name: ROUTE_NAME.BOOKINGS_SERVICE_EDIT,
    meta: { requiresPayments: true },
    component: () => import("./views/EditServiceView.vue"),
    props: true,
  },
  {
    path: "/bookings/instructors/create",
    name: ROUTE_NAME.BOOKINGS_INSTRUCTOR_CREATE,
    meta: { requiresPayments: true },
    component: () => import("./views/CreateInstructorView.vue"),
    props: true,
  },
  {
    path: "/bookings/instructors/edit/:id",
    name: ROUTE_NAME.BOOKINGS_INSTRUCTOR_EDIT,
    meta: { requiresPayments: true },
    component: () => import("./views/EditInstructorView.vue"),
    props: true,
  },
  {
    path: "/bookings/assets/create",
    name: ROUTE_NAME.BOOKINGS_ASSET_CREATE,
    meta: { requiresPayments: true },
    component: () => import("./views/CreateFacilityAssetView.vue"),
  },
  {
    path: "/bookings/assets/edit/:id",
    name: ROUTE_NAME.BOOKINGS_ASSET_EDIT,
    meta: { requiresPayments: true },
    component: () => import("./views/EditFacilityAssetView.vue"),
    props: true,
  },
  {
    path: "/bookings/create",
    name: ROUTE_NAME.BOOKINGS_CREATE,
    meta: { requiresPayments: true },
    redirect: (to) => ({
      name: ROUTE_NAME.BOOKINGS,
      query: { ...to.query, createBooking: "true" },
    }),
  },
];
